import { render, staticRenderFns } from "./mpModule4.vue?vue&type=template&id=3868912c&scoped=true"
import script from "./mpModule4.vue?vue&type=script&lang=js"
export * from "./mpModule4.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3868912c",
  null
  
)

export default component.exports